import { actionTypes } from '../actions/actionTypes'

const INITIAL_STATE = {
  isAnswerLoaded: false,
}

export default function answerSheet(state = INITIAL_STATE, action) {
  switch (action.type) {
    case actionTypes.LOADED_ANSWER:
      return {
        isAnswerLoaded: true,
        ...action.row,
      }
    case actionTypes.FAIL_TO_LOAD_ANSWER:
      return {
        isAnswerLoaded: true,
      }
    case actionTypes.RESET_ANSWER:
      return {
        isAnswerLoaded: false,
      }
    default:
      return state
  }
}
